import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Source_Sans_3%22,%22arguments%22:[{%22variable%22:%22--font-source_sans_3%22,%22subsets%22:[%22latin%22],%22display%22:%22swap%22}],%22variableName%22:%22sourceSans3%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Source Sans 3', 'Source Sans 3 Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
